import React, { useState, useEffect } from "react";
import FormInputStyle4 from "../../UIElements/FormInput";
import FormSelectStyle4 from "../../UIElements/FormSelect";
import CustomCheckbox from "../customCheckBox/customCheckBox";
import FormButtonStyle4 from "../../UIElements/FormButton";
import callApi from "../../../../utility/apiCaller";
import { setUserClickData } from "../../../../utility/setUserClickData";
import { toast } from "react-toastify";
import getStateFromPincode from "../../Utils/stateMapperfnction";
import { getAllianceLeadFromMoneyTapInput } from "../../../../utility/commonUtils";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { setInternalLead } from "../../../../store/app/aaSlice";
import useAddLead from "../../hooks/addLeadtoCRM";
import useUserEvent from "../../../../hooks/setUserclickhook";

function PersonalDetailsForm({
  isFormStarted,
  setIsFormStarted,
  currentStep,
  setCurrentStep,
  setMobileForOTP,
  formData,
  setFormData,
}) {
  const [gender, setGender] = useState("");
  //const [name, setName] = useState("");
  const [errors, setErrors] = useState({});
  const [dob, setDob] = useState(null);
  const [mobile, setMobile] = useState("");
  const [isMobileValid, setIsMobileValid] = useState(true);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [pancard, setPan] = useState("");
  const [isPanValid, setIsPanValid] = useState(true);
  const [pincode, setPincode] = useState("");
  const [professionType, setprofessionType] = useState("");
  const [showErrors, setShowErrors] = useState(false);
  const [checked, setChecked] = useState(true);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isConsentChecked, setIsConsentChecked] = useState(false);
  const [pincodeValidation, setpincodeValidation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.app.user);
  const [params] = useSearchParams();
  const dispatch = useDispatch();
  const aaSlice = useSelector((state) => state?.aa);
  const InternalLeadId = aaSlice?.internalLeadId;
  const addLead = useAddLead();
  const [searchParams] = useSearchParams();

  const a = Number(params.get("a"));

  const { trackUserEvent } = useUserEvent();

  const handleMobileChange = (event) => {
    let value = event.target.value;

    // Remove any non-digit characters
    value = value.replace(/\D/g, "");

    // Limit to 10 digits
    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    // Allow only if first digit is 6, 7, 8, or 9 (if length >= 1)
    if (value.length === 0 || /^[6-9]/.test(value)) {
      setMobile(value);
      setFormData((prev) => ({
        ...prev,
        mobile: value,
      }));
      setMobileForOTP(value);

      // Validate: length must be exactly 10 and no digit repeats more than 8 times consecutively
      const hasInvalidRepetition = /(.)\1{8,}/.test(value); // matches any digit repeated 9 or more times

      setIsMobileValid(value.length === 10 && !hasInvalidRepetition);
    }
  };

  useEffect(() => {
    if (!formData) return;

    //setName(formData.name || "");
    setMobile(formData.mobile || "");
    setEmail(formData.email || "");
    setGender(formData.gender || "");
    setPan(formData.pancard || "");
    setPincode(formData.pincode || "");
    setprofessionType(formData.professionType || "");
    setDob(formData.dob || null);

    // Optional validation setters
  }, []);

  const handleDobChange = (e) => {
    const value = e.target.value;
    const selectedDate = new Date(value);
    const bufferDate = new Date(maxDate); // assuming maxDate is like '2025-09-16'
    const minDate = new Date("1950-01-01");

    const today = new Date();

    if (selectedDate < minDate) {
      setErrors((prev) => ({
        ...prev,
        dob: "Date cannot be less than 1st Jan 1950",
      }));
    } else if (selectedDate > today) {
      // If date is in the future, show error
      setErrors((prev) => ({
        ...prev,
        dob: "Date of birth cannot be in the future",
      }));
    } else if (selectedDate > bufferDate && selectedDate <= today) {
      setErrors((prev) => ({
        ...prev,
        dob: `You must be at least 18 years old`,
      }));
    } else {
      // Date is valid
      setErrors((prev) => {
        const { dob, ...rest } = prev;
        return rest;
      });
    }

    setDob(value);
  };

  const handleEmailChange = (event) => {
    const value = event.target.value.trim();

    setEmail(value);
    setFormData((prev) => ({
      ...prev,
      email: value,
    }));

    // Always validate live
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsEmailValid(emailRegex.test(value));
  };

  const handlePanChange = (e) => {
    const value = e.target.value.toUpperCase();
    setPan(value);

    // Always validate live
    const isValid = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value);
    setIsPanValid(isValid && value.length === 10); // only invalid if length = 10 & pattern fails
  };

  const handlePincodeChange = async (value) => {
    value = value.replace(/\D/g, ""); // allow only digits

    if (/^\d{0,6}$/.test(value)) {
      // Prevent first digit being 0 if there's at least one digit
      if (value.length > 0 && value[0] === "0") {
        return; // ignore input if first digit is 0
      }

      setPincode(value); // always update input field

      // clear error if user is still typing
      if (errors.pincode) {
        setErrors((prev) => ({ ...prev, pincode: false }));
      }

      // Only validate when user has entered 6 digits
      if (value.length === 6) {
        setpincodeValidation(true); // start loading state

        try {
          // ✅ call your backend API using callApi instead of fetch
          const response = await callApi(
            `v1/util/${value}`, // backend route
            "get", // HTTP method
            {}, // body (not needed for GET)
            "core" // service key
          );

          if (!response.success) {
            setErrors((prev) => ({ ...prev, pincode: true }));
          } else {
            setErrors((prev) => ({ ...prev, pincode: false }));
            setFormData((prev) => ({
              ...prev,
              city: response.city,
              state: getStateFromPincode(value),
            }));

            console.log("Valid Pincode, City:", response.city);
          }
        } catch (error) {
          console.error("Pincode validation error:", error);
          setErrors((prev) => ({ ...prev, pincode: true }));
        } finally {
          setpincodeValidation(false); // end loading state
        }
      }
    }
  };

  const handleProfessionChnage = (value) => {
    //console.log(value);
    setprofessionType(value);
    if (errors.professionType) {
      setErrors((prev) => ({ ...prev, professionType: false }));
    }
  };

  // const handleNameChange = (e) => {
  //   let newName = e.target.value;

  //   // Remove any character that is not a letter or space
  //   newName = newName.replace(/[^A-Za-z\s]/g, "");

  //   // Replace multiple spaces with a single space
  //   newName = newName.replace(/\s+/g, " ");

  //   setName(newName);

  //   // Validate: name must have at least 2 characters after trimming
  //   setErrors((prev) => ({
  //     ...prev,
  //     name: newName.trim().length < 2,
  //   }));
  // };

  //console.log("Personal formData:", formData);

  useEffect(() => {
    const allValid =
      gender &&
      //name.trim() &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) &&
      (!errors.email || errors.email === false) &&
      /^\d{6}$/.test(pincode) &&
      (!errors.pincode || errors.pincode === false || pincodeValidation) &&
      professionType &&
      (!errors.professionType || errors.professionType === false) &&
      pancard &&
      (!errors.pan || errors.pan === false) &&
      isPanValid &&
      isConsentChecked &&
      dob &&
      (!errors.dob || errors.dob === false);

    setIsFormValid(allValid);
  }, [
    gender,
    //name,
    email,
    errors.email,
    dob,
    errors.dob,
    pincode,
    errors.pincode,
    professionType,
    errors.professionType,
    pancard,
    errors.pan,
    isPanValid,
    isConsentChecked,
  ]);

  useEffect(() => {
    if (formData) {
      setGender(formData.gender || "");
      //setName(formData.name || "");
      setMobile(formData.mobile || "");
      setPan(formData.pancard || "");
      setEmail(formData.email || "");
      setPincode(formData.pincode || "");
      setprofessionType(formData.professionType || "");
      setDob(formData.dob || null);
      setIsConsentChecked(formData.mobiletncchecked || false);
      // setFormData((prev) => ({
      //   ...prev,
      // setIpAddress(ipAddress);
    }
  }, []);

  let allianceId = "website-pl-ete-lead";

  if (a == 2) {
    allianceId = "zv2";
  } else if (a == 3) {
    allianceId = "cashe";
  } else if (a == 4) {
    allianceId = "bharatpe";
  }

  const handleConsentChange = async () => {
    setIsConsentChecked((prev) => {
      const newValue = !prev;
      //console.log("Old:", prev, "New:", newValue);
      return newValue;
    });
  };
  const handleValidateAndSendOtp = async () => {
    // Step 1: Validate form
    if (!handleValidation()) {
      return;
    }

    // Step 2: Consent already taken on Mobile OTP page

    try {
      setIsLoading(true);

      // Step 3: Call API to send OTP

      // Step 4: Handle API response

      //  affId ||

      // Step 5: Update form data only after OTP sent
      setFormData((prev) => ({
        ...prev,
        gender,
        pancard,
        //name,
        email,
        pincode,
        professionType,
        mobile,
        dob,
        mobiletncchecked: true,
        mobiletnctime: new Date().toISOString(),
      }));

      const trackId = localStorage.getItem("track_id");

      const url = InternalLeadId
        ? `v1/lead/${InternalLeadId}/update-lead-new`
        : "v1/lead/dmi-lead";

      const res = await callApi(
        url,
        "post",
        {
          lead: {
            tracking_id: trackId,
            contact_phone: mobile,
            contact_email: email,
            //contact_name: name,
            dob: dob,
            gender: gender,
            pincode,
            city: formData.city,
            state: formData.state,
            pancard: pancard,
            profession_type: professionType,
            steps_completed: 2,
            alliance_id: allianceId,
            aff_id: params.get("aff_id"),
            utm_source: params.get("utm_source")?.split("?")[0],
            source: params.get("source"),
            utm_medium: params.get("utm_medium"),
            utm_term: params.get("utm_term"),
            ads_name: params.get("ads_name"),
          },
        },
        "core",
        user?.token ||
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTMxNTQ2NDEwYjdkNTgzMDA3NjIyYmEiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk5MjIxODcwMDUiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMi0wNFQwOTozOTowOC42NjhaIiwiaWF0IjoxNzY0ODQwNTU0fQ.ksMJv8yeMuVZvk6EtBuajtH1-CuCvtvFmv2X-1Ab71Y"
      );
      await callApi(
        `v1/lead/customer-check-e2e`,
        "post",
        {
          lead: {
            tracking_id: trackId,
            contact_phone: mobile,
            contact_email: email,
            //contact_name: name,
            dob: dob,
            gender: gender,
            pincode,
            city: formData.city,
            state: formData.state,
            pancard: pancard,
            profession_type: professionType,
            steps_completed: 2,
            alliance_id: allianceId,
            aff_id: params.get("aff_id"),
            utm_source: params.get("utm_source")?.split("?")[0],
            source: params.get("source"),
            utm_medium: params.get("utm_medium"),
            utm_term: params.get("utm_term"),
            ads_name: params.get("ads_name"),
          },
        },
        "core",
        user?.token ||
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTMxNTQ2NDEwYjdkNTgzMDA3NjIyYmEiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk5MjIxODcwMDUiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMi0wNFQwOTozOTowOC42NjhaIiwiaWF0IjoxNzY0ODQwNTU0fQ.ksMJv8yeMuVZvk6EtBuajtH1-CuCvtvFmv2X-1Ab71Y"
      );
      const finalLeadId = InternalLeadId || res?.data?.lead?._id;
      if (!InternalLeadId) {
        dispatch(setInternalLead(finalLeadId));
      }
      trackUserEvent(
        "personal-page-prefr-v2-lead",
        res?.data?.lead?._id || InternalLeadId
      );

      toast.success("OTP Sent Successfully");

      // Call useAddLead hook on successful submission
      if (finalLeadId) {
        try {
          await addLead({
            leadId: finalLeadId,
            lead_type: "live",
            priority: 3,
            stage: "Personal Details",
          });
        } catch (error) {
          console.error("Error adding lead to CRM:", error);
        }
      }

      setIsFormStarted(true);

      // Step 6: Move to OTP step
      setCurrentStep((prev) => prev + 1);
    } catch (error) {
      toast.error("An error occurred while sending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    //console.log("Consent checked updated:", isConsentChecked);
  }, [isConsentChecked]);

  const handleValidation = () => {
    setShowErrors(true); // enables red borders

    const newErrors = {};

    if (!gender) newErrors.gender = true;
    if (!dob) newErrors.dob = true;
    //if (!name.trim()) newErrors.name = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = true;
      setIsEmailValid(false);
    }
    if (!/^\d{10}$/.test(mobile)) {
      newErrors.mobile = true;
      setIsMobileValid(false);
    }
    if (!pincode.match(/^\d{6}$/)) newErrors.pincode = true;
    if (!professionType) newErrors.professionType = true;
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pancard)) {
      newErrors.pancard = true;
      setIsPanValid(false);
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const today = new Date();
  const year = today.getFullYear() - 18;
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const maxDate = `${year}-${month}-${day}`;

  return (
    <div>
      <div className="w-full  flex font-polysans -mt-3  justify-center items-center gap-2 text-[#1B1B1B] ">
        <div className="w-[44px] h-[1px] bg-[#B3B3B3]" />
        <p className="text-[18px] font-bold xs:text-[16px]">
          Personal information
        </p>

        <div className="w-[44px] h-[1px] bg-[#B3B3B3]" />
      </div>
      <p className="text-[12px] text-[#8B8B8B] xs:text-[12px] text-center mb-3">
        We will use your contact details to proceed further.
      </p>

      <div className="flex flex-wrap gap-2 mb-3  items-center justify-center">
        {/* Male Button */}
        <button
          className={`flex items-center justify-center w-[165px] xs:w-[150px] sm:w-[165px] h-[55px] sm:h-[55px] border-[1px] rounded-md text-base cursor-pointer font-atkinson transition-colors duration-200 ${
            gender.toLocaleLowerCase() === "Male".toLocaleLowerCase()
              ? "bg-neutral-900 text-green-400 border-neutral-900"
              : "bg-white text-black border-gray-400 hover:bg-gray-100"
          }`}
          onClick={() => setGender("Male")}
        >
          <div className="flex items-center gap-2">
            <img
              src={
                gender === "Male"
                  ? "/assets/img/Male_green.svg"
                  : "/assets/img/Male_black.svg"
              }
              alt="Male Icon"
              className="h-5"
            />
            <span>Male</span>
          </div>
        </button>

        {/* Female Button */}
        <button
          className={`flex items-center justify-center w-[165px] xs:w-[150px] sm:w-[165px] h-[55px] sm:h-[55px] border-[1px] rounded-md text-base cursor-pointer font-atkinson transition-colors duration-200 ${
            gender.toLocaleLowerCase() === "Female".toLocaleLowerCase()
              ? "bg-neutral-900 text-green-400 border-neutral-900"
              : "bg-white text-black border-gray-400 hover:bg-gray-100"
          }`}
          onClick={() => setGender("Female")}
        >
          <div className="flex items-center gap-2">
            <img
              src={
                gender === "Female"
                  ? "/assets/img/Female_green.svg"
                  : "/assets/img/Female_black.svg"
              }
              alt="Female Icon"
              className="h-5"
            />
            <span>Female</span>
          </div>
        </button>
      </div>

      {/* <FormInputStyle4
        label="Full Name as per Pan Card"
        value={name}
        maxlength={100}
        onChange={handleNameChange}
        isValid={!errors.name}
        errorMessage="Please enter a valid name with only one space between words"
      /> */}

      <FormInputStyle4
        type="date"
        label="Date of Birth"
        value={dob}
        min={"1950-01-01"}
        onChange={handleDobChange}
        isValid={!errors.dob}
        max={maxDate}
        errorMessage={errors.dob ? errors.dob : "Date of birth is required"}
      />
      <FormInputStyle4
        label="Mobile Number"
        value={mobile}
        isValid={isMobileValid}
        minLength="10"
        maxLength="10"
        pattern="[0-9]{10}"
        inputMode="numeric"
        onChange={handleMobileChange}
        errorMessage="Mobile Number is required"
      />
      <FormInputStyle4
        label="Personal Email Address"
        value={email}
        maxlength={100}
        onChange={handleEmailChange}
        isValid={isEmailValid}
        errorMessage="Enter a valid email"
      />
      <FormInputStyle4
        type="text"
        name="pancard"
        isValid={isPanValid}
        id="pancard"
        minLength="10"
        maxLength="10"
        value={pancard}
        onChange={handlePanChange}
        required
        label={"PAN Card Number"}
        inputMode="text"
        errorMessage={"Please enter a valid PAN Number"}
      />
      <FormInputStyle4
        label="Home Pin Code"
        value={pincode}
        onChange={(e) => handlePincodeChange(e.target.value)}
        onBlur={() => {
          if (!/^\d{6}$/.test(pincode) || errors.pincode) {
            setErrors((prev) => ({ ...prev, pincode: true }));
          }
        }}
        isValid={!errors.pincode}
        errorMessage="Enter a valid 6-digit PIN"
        tick={pincode.length === 6 && !errors.pincode}
        loading={pincodeValidation}
      />

      <FormSelectStyle4
        label="Occupation"
        value={professionType}
        onChange={handleProfessionChnage}
        onBlur={() => {
          if (!professionType) {
            setErrors((prev) => ({ ...prev, professionType: true }));
          }
        }}
        options={[
          { label: "Salaried", value: "salaried" },
          { label: "Self-Employed", value: "self_employed" },
          // { label: "Business Owner", value: "business owner" },
        ]}
        isValid={!errors.professionType}
        errorMessage="Please select professionType"
      />

      {/* Consent hidden - always true by default */}

      <FormButtonStyle4
        className="mt-3"
        text="Continue"
        disabled={!isFormValid || isLoading || pincodeValidation}
        isLoading={isLoading}
        onClick={handleValidateAndSendOtp}
      />
    </div>
  );
}

export default PersonalDetailsForm;
